// extracted by mini-css-extract-plugin
export default {"container":"TrainingPage_container__tNWnF","barContainer":"TrainingPage_barContainer__8sH48"};